export const basePackingItems = {
  adult: {
    clothing: ["Tops", "Bottoms", "Underwear", "Socks", "Sleepwear", "Shoes", "Belt"],
    toiletries: ["Deodorant", "Razor", "Shaving Cream", "Hairbrush/Comb",
     "Toothbrush","Toothpaste", "Floss", "Shampoo", "Conditioner", "Body Wash", "Lotion",
     "Nail Clippers", "Skincare Products"],
    electronics: ["Phone", "Chargers", "Smart Watch", "Headphones", 
      "Laptop", "Tablet", "Power bank"],
    other: ["Keys", "Wallet", "ID/Passport", "Sunglasses", "Travel tissues", "Water Bottle"]
  },
  // ✅ Add child age group packing lists
  kids: {
    "0-12M": {
      clothing: ["Onesies", "Socks/Mittens", "Hat", "Tops", "Bottoms", "Pajamas", "Extra Outfits"],
      toiletries: ["Wet wipes", "Baby lotion", "Pacifiers", "Diapers", "Diaper rash cream", "Burp cloths", "Shampoo", "Body Wash"],
      other: ["Stroller", "Baby monitor", "Sound machine", "Stuffies", "toys", "Diaper bag", "Sleep sack", "Pacifiers", "Nose Sucker"],
      feedingSupplies: ["Bottles", "Formula/Breast pump", "Bib", "Bottle brush", "Nursing cover"]
    },
    "1-3Y": {
      clothing: ["Tops", "Bottoms", "Underwear", "Socks", "Shoes", "Jacket", "Pajamas", "Extra Outfits"],
      toiletries: ["Diapers/Training Pants", "Wet Wipes", "Toothbrush", "Kids toothpaste", "Shampoo", "Body Wash", "Hairbrush/Comb", "Hair Ties"],
      other: ["Stroller", "Stuffies", "Books/activities", "Toys", "Water Bottle/Sippy Cup", "Sound machine", "Baby Monitor", "Pacifiers"]
    },
    "3-5Y": {
      clothing: ["Tops", "Bottoms", "Underwear", "Socks", "Shoes", "Jacket", "Pajamas", "Extra Outfits"],
      toiletries: ["Toothbrush", "Kids toothpaste", "Shampoo", "Body Wash", "Hairbrush/Comb", "Hair Ties"],
      other: ["Stuffies", "Favorite Toy", "Sleepsack/Blanket", "Books/activities"]
    },
    "5-12Y": {
      clothing: ["Tops", "Bottoms", "Underwear", "Socks", "Shoes", "Jacket", "Pajamas"],
      toiletries: ["Toothbrush", "Toothpaste", "Hairbrush/Comb", "Shampoo", "Body Wash", "Hairbrush/Comb", "Hair Ties"],
      other: ["Books/Activities", "Headphones"]
    },
    "12-18Y": {
      clothing: ["Tops", "Bottoms", "Underwear", "Socks", "Sneakers", "Hoodie", "Pajamas"],
      toiletries: ["Toothbrush", "Toothpaste", "Deodorant", "Hair products", "Shampoo", "Body Wash", "Hairbrush/Comb", "Hair Ties"],
      other: ["Headphones", "Phone", "Phone charger", "Notebook"]
    }
  },

  male: {
    toiletries: ["Cologne", "Hair Gel/Paste"]
  },
  female: {
    toiletries: ["Makeup", "Makeup remover", "Hair ties", 'Perfume', "Hair Spray"]
  },
  tripStyles: {
    beach: ["Swimsuit", "Sunscreen", "Flip flops"],
    hiking: ["Hiking boots", "Backpack", "Water bottle"],
    business: ["Laptop", "Notebook", "Business cards"],
    camping: ["Tent", "Sleeping bag", "Insect repellent"]
  },
  extras: {
    formalAttire: {
      male: ["Dress Shirt", "Blazer/Suit Jacket", "Dress Pants", "Tie","Dress Shoes","Belt","Dress Socks"],
      female: ["Dress/Blouse","Blazer/Cardigan","Dress Pants or Skirt","Heels/Flats"]
    },
    gymAttire: ["Athletic Shirt", "Athletic Shorts", "Athletic Shoes"],
    businessCasual: {
      male: ["Polo/Button-up Shirt", "Khakis/Chinos", "Smart Casual Shoes","Belt"],
      female: ["Blouse/Top","Dress Pants/Skirt","Flats/Low Heels","Cardigan"]
    },
    glasses: ["Glasses","Contact Lenses", "Contact Lens Solution"],
    medications: ["Prescription Medications", "Pain Relievers", "Allergy Medicine", "Vitamins"],
    books: ["Books / E-reader"],
    swimAttire: ["Swimsuit", "Towel", "Sunscreen"],
    internationalTravel: ["Travel Adapter", "Passport"]
    
  },
  climates: {
    cold: ["Heavy jacket", "Gloves", "Scarf", "Beanie"],
    hot: ["Sandals", "Hat"],
    mild: ["Light jacket", "Pull Over", "Hoodie/Sweatshirt"],
    wet: ["Raincoat", "Umbrella"]
  }
};
